import { render, staticRenderFns } from "./OrganizationDirectory.vue?vue&type=template&id=d6be4dee&scoped=true"
import script from "./OrganizationDirectory.vue?vue&type=script&lang=js"
export * from "./OrganizationDirectory.vue?vue&type=script&lang=js"
import style0 from "./OrganizationDirectory.vue?vue&type=style&index=0&id=d6be4dee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6be4dee",
  null
  
)

export default component.exports